<template>
  <div>
    <h1 class="title">Gestione utente</h1>

    <div>
      <ul v-if="editUser.id">
        <li v-if="!$ajax.getObject('roles')[editUser.roleId].isClient">
          <router-link :to="`/user/${editUser.id}/cards`">
            <button class="button">
              <b-icon icon="newspaper" size="is-small"></b-icon>
              <span>Visualizza cartelle</span>
            </button>
          </router-link>
        </li>
        <li v-if="$ajax.getObject('roles')[editUser.roleId].isClient">
          <router-link :to="`/user/${editUser.id}/products`">
            <button class="button">
              <b-icon icon="cookie-bite" size="is-small"></b-icon>
              <span>Visualizza prodotti</span>
            </button>
          </router-link>
        </li>
      </ul>
    </div>

    <form v-on:submit="formSubmit">
      <fieldset :disabled="$ajax.anyLoading">
        <b-loading :active.sync="$ajax.anyLoading"></b-loading>

        <div class="section has-text-left">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Nominativo</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    placeholder="Nominativo"
                    v-model.trim="editUser.name"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Email</label>
                <div class="control">
                  <input
                    class="input"
                    type="email"
                    placeholder="Email"
                    v-model.trim="editUser.email"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <!-- maledetto chrome password deve essere successivo a email -->
              <b-field label="Password">
                <template v-if="!$route.params.id"
                  >Lascia il campo vuoto per generare automaticamente una
                  password sicura. Verrà inviata alla mail indicata.</template
                >
                <b-input
                  type="password"
                  class="password"
                  placeholder="Password"
                  v-model="editUser.password"
                  password-reveal
                ></b-input>
              </b-field>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Area di lavoro</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    placeholder="Area di lavoro"
                    v-model.trim="editUser.workingArea"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- RUOLO RUOLO RUOLO RUOLO RUOLO  RUOLO -->
          <b-field label="Ruolo">
            <b-select
              placeholder="Seleziona un ruolo"
              v-model="editUser.roleId"
              required
              :disabled="this.$route.params.id == $ajax.getUser().id"
            >
              <option
                v-for="option in $ajax.getObject('roles')"
                :value="option.id"
                :key="option.id"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>

          <!-- REGIONI REGIONI REGIONI REGIONI REGIONI  -->
          <label class="label">Regioni assegnate</label>
          <div
            class="field"
            v-for="(region, i) in $ajax.getObject('regions')"
            :key="`region_${region.id}_${i}`"
          >
            <b-checkbox
              v-model="editUser.regionIds"
              :native-value="region.id"
              >{{ region.name }}</b-checkbox
            >
          </div>

          <div class="field">
            <b-switch
              v-model="editUser.enabled"
              :true-value="1"
              :false-value="0"
              >Account attivo</b-switch
            >
          </div>
          <div class="buttons is-right">
            <a
              class="button is-danger"
              :disabled="$ajax.anyLoading"
              v-if="editUser.id && $ajax.getUserRole().userDelete"
              v-on:click="onDelete"
            >
              <span class="icon is-small">
                <i class="fas fa-trash"></i>
              </span>
              <span>Elimina utente</span>
            </a>
            <button class="button is-success">
              <b-icon icon="save" size="is-small"></b-icon>
              <span>Salva utente</span>
            </button>
          </div>
        </div>
      </fieldset>
      <!--<pre class="has-text-left">{{editUser}}</pre>-->
    </form>
  </div>
</template>

<script>
import router from "../router.js";

export default {
  name: "user-edit",
  data() {
    return {
      editUser: {
        id: 0,
        name: "",
        email: null,
        password: null,
        roleId: 0,
        enabled: 1,
        activity: 0,
        createdAt: null,
        updatedAt: null,
        regionIds: [],
        workingArea: "",
      },
    };
  },
  methods: {
    formSubmit(e) {
      e.preventDefault();

      if (this.$route.params.id) {
        this.formUpdate();
      } else this.formCreate();
    },
    formCreate() {
      const vm = this;
      this.$ajax.request({
        address: "/users",
        method: "POST",
        data: this.editUser,
        onSuccess: (response) => {
          vm.editUser = response.data;
          router.push({ name: "user", params: { id: response.data.id } });
        },
      });
    },
    formUpdate() {
      const vm = this;
      this.$ajax.request({
        address: "/users/" + this.$route.params.id,
        method: "PUT",
        data: this.editUser,
        onSuccess: (response) => {
          vm.editUser = response.data;
          if (vm.editUser.id == this.$ajax.getUser().id)
            this.$ajax.setUser(vm.editUser);
        },
      });
    },
    onDelete() {
      const vm = this;
      this.$buefy.dialog.confirm({
        title: "Cancella utente",
        message: `Sei sicuro di voler <b>eliminare</b> questo utente? Verranno rimossi tutti gli elementi collegati. <b>Questa azione è irreversibile</b>.`,
        confirmText: "Elimina",
        cancelText: "Annulla",
        type: "is-danger",
        scroll: "keep",
        hasIcon: true,
        onConfirm: () => {
          this.$ajax.request({
            address: "/users/" + this.editUser.id,
            method: "DELETE",
            onSuccess: (response) => {
              router.push({ name: "users" });
            },
          });
        },
      });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      // id opzionale
      const vm = this;
      this.$ajax.request({
        address: "/users/" + this.$route.params.id,
        method: "GET",
        onSuccess: (response) => {
          vm.editUser = response.data;
        },
      });
    }
  },
};
</script>